import * as Yup from 'yup';

import { translate } from '@utils';

export const getValidationSchema = () => {
  return Yup.object({
    mortgage_in_2_years: Yup.bool(),
    auto_in_2_years: Yup.bool(),
    none: Yup.bool(),
  })
    .test((value) => {
      return value.mortgage_in_2_years || value.auto_in_2_years || value.none;
    })
    .required(translate('subModules/futureLoanPlans:validation.required'));
};
